"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioCommentary = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _card_component = require("../global_components/card_component");

var _card_component2 = _interopRequireDefault(_card_component);

var _sanitize_utility = require("common-utilities/src/sanitize_utility");

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _reactIntl = require("react-intl");

var _date_formatter = require("common-utilities/src/date_formatter");

var _functional_utility = require("common-utilities/src/functional_utility");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AudioCommentary = exports.AudioCommentary = function AudioCommentary(props) {
  return _react2.default.createElement(
    _card_component2.default,
    {
      headerTitle: "Monthly Audio Commentary",
      headerTitleId: "audio-commentary-id",
      headerTitleLabel: "audio-commentary-label",
      disclosureText: "",
      placementId: "",
      dataTest: "audio-commentary",
      headerLabel: !(0, _functional_utility.isNilOrEmpty)(props.audioCommentary.date) && _react2.default.createElement(
        "span",
        { "data-testid": "audio-commentary-as-of-date",
          className: "text-left text-muted  font-light disclaimer font-warm-grey" },
        "As of ",
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'date-format', defaultMessage: props.audioCommentary.date, values: (0, _date_formatter.formattedDateValObj)(props.audioCommentary.date, false) })
      )
    },
    _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(props.audioCommentary.audioContent) } })
  );
};